/* ── HERO SLIDESHOW ── */
(function(){
  var slider = document.getElementById('mg-slider');
  if (!slider) return;
  var slides = slider.querySelectorAll('.mg-slide');
  var dots = slider.querySelectorAll('.mg-sl-dot');
  var prevBtn = slider.querySelector('.mg-sl-arrow--prev');
  var nextBtn = slider.querySelector('.mg-sl-arrow--next');
  var cur = 0;
  var total = slides.length;
  var timer;

  function go(i) {
    cur = (i + total) % total;
    slides.forEach(function(s, idx){ s.classList.toggle('is-active', idx === cur); });
    dots.forEach(function(d, idx){ d.classList.toggle('is-active', idx === cur); });
  }
  function next(){ go(cur + 1); }
  function prev(){ go(cur - 1); }
  function loop(){ clearInterval(timer); timer = setInterval(next, 4500); }

  nextBtn && nextBtn.addEventListener('click', function(){ next(); loop(); });
  prevBtn && prevBtn.addEventListener('click', function(){ prev(); loop(); });
  dots.forEach(function(d, i){ d.addEventListener('click', function(){ go(i); loop(); }); });
  loop();

  /* Swipe touch */
  var startX = 0, dx = 0;
  slider.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; dx = 0; }, {passive:true});
  slider.addEventListener('touchmove',  function(e){ dx = e.touches[0].clientX - startX; }, {passive:true});
  slider.addEventListener('touchend',   function(){ if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); loop(); } });
})();

/* ── REVEAL ON SCROLL ── */
(function(){
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.js-reveal').forEach(function(el){ el.classList.add('is-visible'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.js-reveal').forEach(function(el){ io.observe(el); });
})();

/* ── COUNTDOWN 24H (hero + oferta sincronizados) ── */
(function(){
  var hEls = document.querySelectorAll('.js-cd-h');
  var mEls = document.querySelectorAll('.js-cd-m');
  var sEls = document.querySelectorAll('.js-cd-s');
  if (!hEls.length) return;
  var KEY = 'mg-cd-end';
  var end = parseInt(localStorage.getItem(KEY) || '0', 10);
  var now = Date.now();
  if (!end || end < now) {
    end = now + 24 * 60 * 60 * 1000;
    localStorage.setItem(KEY, end);
  }
  function put(list, val){ for (var i = 0; i < list.length; i++) list[i].textContent = val; }
  function tick(){
    var left = end - Date.now();
    if (left < 0) {
      end = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem(KEY, end);
      left = end - Date.now();
    }
    put(hEls, String(Math.floor(left / 3600000)).padStart(2, '0'));
    put(mEls, String(Math.floor((left % 3600000) / 60000)).padStart(2, '0'));
    put(sEls, String(Math.floor((left % 60000) / 1000)).padStart(2, '0'));
  }
  tick();
  setInterval(tick, 1000);
})();

/* ── VIEWERS EN VIVO ── */
(function(){
  var el = document.getElementById('mg-live-num');
  if (!el) return;
  var n = 54;
  setInterval(function(){
    n += Math.floor(Math.random() * 7) - 3;
    if (n < 38) n = 38;
    if (n > 72) n = 72;
    el.textContent = n;
  }, 3000);
})();

/* ── TOAST COMPRAS RECIENTES ── */
(function(){
  var t = document.getElementById('mg-toast');
  if (!t) return;
  var nameEl = document.getElementById('mg-toast-name');
  var metaEl = document.getElementById('mg-toast-meta');
  var names = ['Andrés','Laura','Carlos','Daniela','Juan','Sofía','Mateo','Valentina','Andrea','Sebastián','Camila','David'];
  var cities = ['Medellín','Bogotá','Cali','Barranquilla','Bucaramanga','Cartagena','Pereira','Cúcuta','Ibagué','Manizales'];
  var mins = ['hace 1 min','hace 2 min','hace 4 min','hace 6 min','hace 8 min','hace 11 min'];
  function rnd(a){ return a[Math.floor(Math.random() * a.length)]; }
  function show(){
    nameEl.textContent = rnd(names);
    metaEl.textContent = rnd(cities) + ' · ' + rnd(mins);
    t.classList.add('is-show');
    setTimeout(function(){ t.classList.remove('is-show'); }, 4500);
    setTimeout(show, 10500 + Math.random() * 5000);
  }
  setTimeout(show, 4000);
})();
